import NarrativeCaseStudy from "../../components/NarrativeCaseStudy";
import drivingApp from "../../constrains/cases/drivingApp";

export default function DrivingApp() {
  return <NarrativeCaseStudy caseStudy={drivingApp} />;
}
